import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MediaData, MediaDialogComponent } from './media-dialog.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'sentry-media-preview',
    templateUrl: './media-preview.component.html',
    styleUrls: ['./media-preview.component.scss'],
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MediaDialogComponent]
})
export class MediaPreviewComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('videoPlayer') videoPlayer: ElementRef | undefined;

  @Input() mediaPath: string | null = null;
  @Input() showFullViewButton = true;
  @Output() videoFinished$ = new EventEmitter<boolean>();

  isVideoType = false;
  isImageType = false;

  private destroy$ = new Subject<void>();

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
    if (this.mediaPath) {
      const lowerCasePath = this.mediaPath.toLowerCase();
      this.isVideoType =
        lowerCasePath.endsWith('.mp4') || lowerCasePath.endsWith('.mov');
      this.isImageType =
        lowerCasePath.endsWith('.jpeg') ||
        lowerCasePath.endsWith('.png') ||
        lowerCasePath.endsWith('.jpg');
    }
  }

  ngAfterViewInit(): void {
    if (!this.videoPlayer) {
      return;
    }

    this.videoPlayer.nativeElement.onended = () => {
      this.videoFinished$.emit(true);
    };
  }

  mediaClick() {
    const data: MediaData = {
      mediaPath: this.mediaPath,
    };
    const dialogRef = this.dialog.open(MediaDialogComponent, {
      data,
      maxWidth: '95vw',
      maxHeight: '95vh',
      height: '95%',
      width: '95%',
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        console.log(`Dialog result: ${result}`);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
